import { useScroll } from 'ahooks';

export const usePageScrollTop = (): number => {
  const { top } = useScroll(document.querySelector('#page')! as HTMLDivElement);

  return top;
};
